import { defaultHttpClient } from '../../httpClient';
import type { PatchMemberInfoRequest } from './types';

export const patchMemberInfo = async (data: PatchMemberInfoRequest) => {
  return defaultHttpClient
    .request<void>({
      method: 'PUT',
      url: '/api/v2/members/me/',
      data,
    })
    .then(result => result.data);
};
